<template>
  <div id="app">
    <router-view v-if="appCanBeStarted" />
    <span class="App__Loader" v-show="isLoading">
      <svgicon name="loading" :original="true"></svgicon>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import '@/components/icons'

export default {
  name: 'app',
  components: {},
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      title: 'sections/getTitle',
      isLoading: 'app/isLoading',
      appCanBeStarted: 'app/appCanBeStarted'
    })
  },
  watch: {
    title () {
      if (!this.title) {
        document.title = this.$t('head.title')
      } else {
        document.title = this.$t('head.title') + ' - ' + this.title
      }
    }
  },
  mounted () {
    if (window.location === window.parent.location) {
      this.$store.commit('app/ROOTURL_UPDATED', window.location)
    }
  }
}
</script>

<style>
body, html {
  padding: 0;
  margin: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s, transform 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(25%);
}

.fading-enter-active, .fading-leave-active {
  transition: opacity 0.2s;
}
.fading-enter, .fading-leave-to {
  opacity: 0;
}
</style>

<style lang="scss" scoped>
#app {
  padding: 16px;
  position: relative;
}

.App {
  &__Loader {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(250, 250, 250, 0.9);

    svg {
      width: 32px;
      height: 32px;
      animation: rotating 1s linear infinite;
      position: absolute;
      top: 250px;
      left: calc(50% - 16px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue